import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteIcon } from "../../../../common/icons/delete.svg";
import { ReactComponent as EditIcon } from "../../../../common/icons/editDark.svg";
import theme from "../../../../theme";

type Props = {
  open: boolean;
  anchorEl: any;
  onClose: () => void;
  rowId: string;
  canModify: boolean;
  onEditRow: (id: string) => void;
  onDeleteRow: (id: string) => void;
};

export const ActionMenu = ({
  open,
  anchorEl,
  onClose,
  rowId,
  onEditRow,
  onDeleteRow,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Menu open={open} anchorEl={anchorEl} onClose={onClose}>
      <List dense disablePadding>
        <>
          <ListItem disablePadding>
            <ListItemButton
              sx={{ paddingLeft: "13px", paddingRight: "13px" }}
              onClick={() => {
                onEditRow(rowId);
                onClose();
              }}
            >
              <ListItemIcon sx={{ minWidth: "13px", marginRight: "13px" }}>
                <EditIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography>{t("common:edit")}</Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton
              sx={{
                paddingLeft: "13px",
                paddingRight: "13px",
              }}
              onClick={() => {
                onDeleteRow(rowId);
                onClose();
              }}
            >
              <ListItemIcon
                sx={{
                  width: "13px",
                  minWidth: "13px",
                  marginRight: "13px",
                }}
              >
                <DeleteIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography color={theme.palette.error.main}>
                  {t("common:delete")}
                </Typography>
              </ListItemText>
            </ListItemButton>
          </ListItem>
        </>
      </List>
    </Menu>
  );
};
